import css from 'styled-jsx/css'

import { fontWeights } from "app/theme";

export default css`
  header{
    font-size: 1.2rem;
    font-weight: ${fontWeights.semiBold};
  }

  .container{
    text-align: center;
    padding: 2rem;
  }

  @media screen and (max-width: 992px) {
    .container{
      padding: 1.5rem 1rem 2rem;
    }
  }
`
